export default function CoachingHistory() {
  return (
    <div className="max-w-2xl mx-auto py-16">
      <h1 className="text-3xl font-bold text-indigo-800 mb-8">Coaching History</h1>
      <p className="text-gray-700">View your past coaching sessions and programs here.</p>
    </div>
  );
}
